var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.804-102.804v-152.218L687.782-840q8.24-7.478 19.069-11.957 10.829-4.478 23.562-4.478 10.894 0 21.262 4.098T771.761-841l69.478 69q8.478 9.717 12.337 20.55 3.859 10.834 3.859 21.786 0 11.968-4.359 23.186-4.359 11.217-11.837 18.696L255.261-102.804H102.804ZM733.13-690.13l40-40.522-41.239-41.478-41 40 42.239 42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a4925663f76d21881ea81bf491d23857.svg";
export { ForwardRef as ReactComponent };